import ValidateError from '../ValidateError';
import context from '../../../../main';

export default {
  valid(question, answer) {
    if (!question.required) {
      return;
    }

    let min = question.limitNum;
    const options = question.additionOptions ? question.additionOptions.concat(question.options) : question.options;
    const { length } = options;
    if (min === -1 || length < min) {
      min = length;
    }

    const answeredNum = Object.keys(answer?.groups).length || 0;
    if (answeredNum < min) {
      throw new ValidateError(context.$t('check_min_options', { N: min }));
    }
  },
};
